import Swup from 'swup'
import SwupJsPlugin from '@swup/js-plugin'
import SwupHeadPlugin from '@swup/head-plugin'
import SwupPreloadPlugin from '@swup/preload-plugin'
import SwupDebugPlugin from '@swup/debug-plugin'

// import { projectTransition } from "./transitions/project-transition";
import { defaultTransition } from './transitions/default-transition'
// import { articleTransition } from "./transitions/article-transition";
import { registerSwupHooks } from './hooks'

export const createSwupInstance = (ctx) => {
	const swup = new Swup({
		plugins: [
			new SwupDebugPlugin(),
			new SwupHeadPlugin(),
			new SwupJsPlugin({
				animations: [defaultTransition],
			}),
			new SwupPreloadPlugin(),
		],
	})

	registerSwupHooks(swup, ctx)

	return swup
}
